exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proof-share-recipient-keyword[data-v-15018f67]{display:none;width:auto;height:20px;border:none}#proof-share-recipient-keyword[data-v-15018f67]:focus{background-color:#f8f9fa}", ""]);

// exports
